// Helper function to get key points along the route
export const getKeyPointsAlongRoute = (coordinates: Array<[number, number]>): Array<[number, number]> => {
    if (coordinates.length === 0) return []
    if (coordinates.length === 1) return [coordinates[0]]

    const keyPoints: Array<[number, number]> = []

    // Always include origin
    keyPoints.push(coordinates[0])

    // For longer routes, add some points in between
    if (coordinates.length > 10) {
        // Add up to 3 intermediate points for longer routes
        const step = Math.floor(coordinates.length / 4)
        for (let i = 1; i <= 3; i++) {
            const index = i * step
            if (index < coordinates.length - 1) {
                keyPoints.push(coordinates[index])
            }
        }
    }

    // Always include destination
    keyPoints.push(coordinates[coordinates.length - 1])

    return keyPoints
}
